module.exports = {
	"permanent": "Permanent",
	"buttons": {
		"cancel": "Annuler",
		"close": "Fermer",
		"copy": "Copier",
		"copyFile": "Copier le fichier",
		"copyToClipboard": "Copier dans le presse-papier",
		"create": "Créer",
		"delete": "Supprimer",
		"download": "Télécharger",
		"info": "Info",
		"more": "Plus",
		"move": "Déplacer",
		"moveFile": "Déplacer le fichier",
		"new": "Nouveau",
		"next": "Suivant",
		"ok": "OK",
		"replace": "Remplacer",
		"previous": "Précédent",
		"rename": "Renommer",
		"reportIssue": "Rapport d'erreur",
		"save": "Enregistrer",
		"search": "Chercher",
		"select": "Sélectionner",
		"share": "Partager",
		"publish": "Publier",
		"selectMultiple": "Sélection multiple",
		"schedule": "Fixer la date",
		"switchView": "Changer le mode d'affichage",
		"toggleSidebar": "Afficher/Masquer la barre latérale",
		"update": "Mettre à jour",
		"upload": "Importer",
		"permalink": "Obtenir un lien permanent"
	},
	"errors": {
		"forbidden": "Vous n'êtes pas autorisé à être ici.",
		"internal": "Aïe ! Quelque chose s'est mal passé.",
		"notFound": "Impossible d'accéder à cet emplacement."
	},
	"files": {
		"folders": "Dossiers",
		"files": "Fichiers",
		"body": "Corps",
		"clear": "Fermer",
		"closePreview": "Fermer la prévisualisation",
		"home": "Accueil",
		"lastModified": "Dernière modification",
		"loading": "Chargement...",
		"lonely": "Il semble qu'il n'y ai rien par ici...",
		"metadata": "Metadonnées",
		"multipleSelectionEnabled": "Sélection multiple activée",
		"name": "Nom",
		"size": "Taille",
		"sortByName": "Trier par nom",
		"sortBySize": "Trier par taille",
		"sortByLastModified": "Trier par date de dernière modification"
	},
	"help": {
		"click": "Sélectionner un élément",
		"ctrl": {
			"click": "Sélectionner plusieurs éléments",
			"f": "Ouvrir l'invité de recherche",
			"s": "Télécharger l'élément actuel"
		},
		"del": "Supprimer les éléments sélectionnés",
		"doubleClick": "Ouvrir un élément",
		"esc": "Désélectionner et/ou fermer la boîte de dialogue",
		"f1": "Ouvrir l'aide",
		"f2": "Renommer le fichier",
		"help": "Aide"
	},
	"login": {
		"password": "Mot de passe",
		"submit": "Se connecter",
		"username": "Utilisateur",
		"wrongCredentials": "Identifiants incorrects !"
	},
	"prompts": {
		"copy": "Copier",
		"copyMessage": "Choisissez l'emplacement où copier la sélection :",
		"currentlyNavigating": "Dossier courant :",
		"deleteMessageMultiple": "Etes-vous sûr de vouloir supprimer ces {count} élément(s) ?",
		"deleteMessageSingle": "Etes-vous sûr de vouloir supprimer cet élément ?",
		"deleteTitle": "Supprimer",
		"displayName": "Nom :",
		"download": "Télécharger",
		"downloadMessage": "Choisissez le format de téléchargement :",
		"error": "Quelque chose s'est mal passé",
		"fileInfo": "Informations",
		"filesSelected": "{count} éléments sélectionnés",
		"lastModified": "Dernière modification",
		"move": "Déplacer",
		"moveMessage": "Choisissez l'emplacement où déplacer la sélection :",
		"newDir": "Nouveau dossier",
		"newDirMessage": "Nom du nouveau dossier :",
		"newFile": "Nouveau fichier",
		"newFileMessage": "Nom du nouveau fichier :",
		"numberDirs": "Nombre de dossiers",
		"numberFiles": "Nombre de fichiers",
		"replace": "Remplacer",
		"replaceMessage": "Un des fichiers que vous êtes en train d'importer a le même nom qu'un autre déjà présent. Voulez-vous remplacer le fichier actuel par le nouveau ?\n",
		"rename": "Renommer",
		"renameMessage": "Nouveau nom pour",
		"show": "Montrer",
		"size": "Taille",
		"schedule": "Fixer la date",
		"scheduleMessage": "Choisissez une date pour planifier la publication de ce post",
		"newArchetype": "Créer un nouveau post basé sur un archétype. Votre fichier sera créé dans le dossier de contenu."
	},
	"settings": {
		"admin": "Admin",
		"administrator": "Administrateur",
		"allowCommands": "Exécuter des commandes",
		"allowEdit": "Editer, renommer et supprimer des fichiers ou des dossiers",
		"allowNew": "Créer de nouveaux fichiers et dossiers",
		"allowPublish": "Publier de nouveaux posts et pages",
		"avoidChanges": "(Laisser vide pour conserver l'actuel)",
		"changePassword": "Modifier le mot de passe",
		"commands": "Commandes",
		"commandsHelp": "Ici vous pouvez définir des commandes qui seront exécutées lors de l'évènement correspondant. Vous devez indiquer une commande par ligne. Si l'évènement est en rapport avec des fichiers, par exemple avant et après enregistrement, la variable d'environement \"FILE\" sera disponible et contiendra le chemin d'accès vers le fichier.\n",
		"commandsUpdated": "Commandes mises à jour !",
		"customStylesheet": "Feuille de style personnalisée",
		"examples": "Exemples",
		"globalSettings": "Paramètres généraux",
		"language": "Langue",
		"newPassword": "Votre nouveau mot de passe",
		"newPasswordConfirm": "Confirmation du nouveau mot de passe",
		"newUser": "Nouvel Utilisateur",
		"password": "Mot de passe",
		"passwordUpdated": "Mot de passe mis à jour !",
		"permissions": "Permissions",
		"permissionsHelp": "Vous pouvez définir l'utilisateur comme étant un administrateur ou encore choisir les permissions individuellement. Si vous sélectionnez \"Administrateur\", toutes les autres options seront automatiquement activées. La gestion des utilisateurs est un privilège que seul l'administrateur possède.\n",
		"profileSettings": "Paramètres du profil",
		"ruleExample1": "Bloque l'accès à tous les fichiers commençant par un point (comme par exemple .git, .gitignore) dans tous les dossiers",
		"ruleExample2": "Bloque l'accès au fichier nommé \"Caddyfile\" à la racine du dossier utilisateur",
		"rules": "Règles",
		"rulesHelp1": "Vous pouvez définir ici un ensemble de règles pour cet utilisateur. Les fichiers bloqués ne seront pas affichés et ne seront pas accessibles par l'utilisateur. Les expressions régulières sont supportées et les chemins d'accès sont relatifs par rapport au dossier de l'utilisateur.\n",
		"rulesHelp2": "Chaque règle est définie sur une ligne différente et doit commencer par le mot clé {0} ou {1}. Vous devez ensuite ajouter {2} si vous utilisez une expression régulière puis l'expression en question ou bien seulement le chemin d'accès.\n",
		"scope": "Portée du dossier utilisateur",
		"settingsUpdated": "Les paramètres ont été mis à jour !",
		"user": "Utilisateur",
		"userCommands": "Commandes",
		"userCommandsHelp": "Une liste séparée par des espaces des commandes permises pour l'utilisateur. Exemple :",
		"userCreated": "Utilisateur créé !",
		"userDeleted": "Utilisateur supprimé !",
		"userManagement": "Gestion des utilisateurs",
		"username": "Nom d'utilisateur",
		"users": "Utilisateurs",
		"userUpdated": "Utilisateur mis à jour !"
	},
	"sidebar": {
		"help": "Aide",
		"logout": "Se déconnecter",
		"myFiles": "Mes fichiers",
		"newFile": "Nouveau fichier",
		"newFolder": "Nouveau dossier",
		"settings": "Paramètres",
		"siteSettings": "Paramètres du site",
		"hugoNew": "Nouveau Hugo",
		"preview": "Prévisualiser"
	},
	"search": {
		"images": "Images",
		"music": "Musique",
		"pdf": "PDF",
		"pressToExecute": "Appuyez sur Entrée pour exécuter",
		"pressToSearch": "Appuyez sur Entrée pour lancer la recherche",
		"search": "Recherche en cours...",
		"searchOrCommand": "Rechercher ou exécuter une commande...",
		"searchOrSupportedCommand": "Lancez une recherche ou exécutez une commande parmis les suivantes :",
		"type": "Tapez votre recherche et appuyez sur Entrée",
		"types": "Types",
		"video": "Video",
		"writeToSearch": "Ecrivez ici pour lancer une recherche"
	},
	"languages": {
		"ar": "العربية",
		"en": "English",
		"it": "Italiano",
		"fr": "Français",
		"pt": "Português",
		"ptBR": "Português (Brasil)",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"de": "Deutsch",
		"ru": "Русский",
		"pl": "Polski",
		"ko": "한국어"
	},
	"time": {
		"unit": "Unité de temps",
		"seconds": "Secondes",
		"minutes": "Minutes",
		"hours": "Heures",
		"days": "Jours"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr.yaml
// module id = 289
// module chunks = 0